import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../services/brief.service";

export function useShortlistInfluencerV2(briefId: string) {
  const {
    mutate: shortlistInfluencer,
    isLoading: isShortlisting,
    isSuccess: isShortlisted,
    error: shortlistError,
  } = useMutation({
    mutationFn: (briefInfluencerId: string) =>
      BriefService.shortlistInfluencer(briefInfluencerId).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },
    onSuccess: (c) => {
      ToastService.success("Creator shortlisted");
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
          exact: false,
        });
        c.invalidateQueries({
          queryKey: [
            ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
            "facets",
            briefId,
          ],
          exact: false,
        });
      }, 1000);
    },
  });

  return {
    shortlistInfluencer,
    isShortlisting,
    isShortlisted,
    shortlistError,
  };
}
